import { render, staticRenderFns } from "./configInput.vue?vue&type=template&id=50f53486&scoped=true&"
import script from "./configInput.vue?vue&type=script&lang=js&"
export * from "./configInput.vue?vue&type=script&lang=js&"
import style0 from "./configInput.vue?vue&type=style&index=0&id=50f53486&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f53486",
  null
  
)

export default component.exports